/**
 * @owner @Appboy/messaging-experience
 */
import { appRemoteLookupValidators } from "@schemas/remoteLookup/appRemoteLookupSchema";
import type { AppRemoteLookupId, AppRemoteLookupItem, AppRemoteLookupFilters } from "@schemas/types";
import type { z } from "zod";

import type { RemoteLookupProvider } from "./types";

export const appProvider: RemoteLookupProvider<AppRemoteLookupId, AppRemoteLookupItem, AppRemoteLookupFilters> = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: {
    ...appRemoteLookupValidators,
    item: appRemoteLookupValidators.item as z.ZodType<AppRemoteLookupItem>,
  },
};
